import getHorizontalScrollMask from "@ui-kit/ScrollShadowContainer/getHorizontalScrollMask";
import { useEffect } from "react";

const DEFAULT_SHADOW_SIZE = 28;

export const useHorizontalScrollShadow = (
	getElement: () => HTMLElement | null,
	shadowSize: number = DEFAULT_SHADOW_SIZE,
) => {
	useEffect(() => {
		const element = getElement();
		if (!element) return;

		let frame = 0;
		let applied: string | null = null;
		const update = () => {
			cancelAnimationFrame(frame);
			frame = requestAnimationFrame(() => {
				const mask = getHorizontalScrollMask(element, shadowSize);
				if (mask === applied) return;
				applied = mask;
				element.style.maskImage = mask;
				element.style.webkitMaskImage = mask;
			});
		};

		update();
		element.addEventListener("scroll", update, { passive: true });
		const observer = new ResizeObserver(update);
		observer.observe(element);
		return () => {
			cancelAnimationFrame(frame);
			element.removeEventListener("scroll", update);
			observer.disconnect();
		};
	}, [getElement, shadowSize]);
};
